import { useState, useEffect, useContext } from 'react';
import ListHeader from '../../SectionHeader';
import TablePagination from '../../TablePaginationComponent';
import useFetchData from '../../../hooks/useFetchData';
import useSort from '../../../hooks/useSort';
import { ReactComponent as SortIcon } from '../../../assets/images/sort.svg';
import Filter from '../../Filter';
import { useNavigate, useSearchParams } from 'react-router-dom';
import GlobalContext from 'contexts';
import SnackBar from 'components/SnackBar';

import globalTranslating from '../../../translate.json';
import OrgTranslate from '../translate.json';
import '../style.scss';

const OrganizationsList = () => {
  const navigate = useNavigate();
  const { setLink } = useContext(GlobalContext);
  const translating = { ...globalTranslating, ...OrgTranslate };
  const [filteredOrgs, setFilteredOrgs] = useState([]);
  const [showSnackbar, setShowSnakbar] = useState(false);
  const [searchParams] = useSearchParams();
  const { data: orgsData, loading } = useFetchData('organization');

  useEffect(() => {
    if (orgsData?.length) setFilteredOrgs(orgsData);
  }, [orgsData]);

  const onFilter = (filteredData) => {
    setFilteredOrgs(filteredData);
  };

  const onResetFilters = () => {
    setFilteredOrgs(orgsData);
  };

  const { showFilters, toggle } = useSort();

  useEffect(() => {
    const isAdded = searchParams.get('added');
    if (isAdded) {
      setShowSnakbar(true);
      searchParams.delete('added');
      window.history.replaceState(
        null,
        '',
        `${window.location.origin}${window.location.pathname}`
      );
    }
  }, []);

  const actionsOrgsList = [
    {
      icon: SortIcon,
      txt: translating.edit,
      handleClickAction: () => {
        showFilters && setFilteredOrgs(orgsData);
        toggle(!showFilters);
      }
    }
  ];

  const tableHeaders = [
    translating.organizationName,
    translating.tz,
    translating.organizationPhone,
    translating.organizationAddress,
    translating.contactName,
    translating.organizationContactEmail,
    translating.organizationContactMobile,
    translating.organizationCreated,
    translating.organizationStatus
  ];

  const columns = [
    { value: 'name', bold: true },
    { value: 'ssn' },
    { value: 'phoneNumber' },
    { value: 'address' },
    { value: 'contactName', bold: true },
    { value: 'email' },
    { value: 'mobile' },
    { value: 'createdAt', format: 'date' },
    { value: 'isActive', sort: true, format: 'status' }
  ];

  const sortFields = [
    {
      type: 'search',
      label: translating.search,
      placeholder: translating.type3Dots,
      name: 'search',
      fields: ['name', 'ssn', 'address', 'contactName', 'mobile']
    },
    {
      type: 'date',
      subType: 'fromDate',
      label: translating.fromDate,
      name: 'fromDate',
      field: 'createAt'
    },
    {
      type: 'date',
      subType: 'toDate',
      label: translating.toDate,
      name: 'toDate',
      field: 'createdAt'
    },
    {
      type: 'select',
      label: translating.status,
      name: 'isActive',
      options: [
        { id: true, name: 'פעיל' },
        { id: false, name: 'חסום' }
      ],
      isId: true
    }
  ];

  return (
    <div className="customers-list">
      <ListHeader
        title={translating.organizationsListTitle}
        actions={actionsOrgsList}
        newItem={{ handleClick: () => setLink('add') }}
      ></ListHeader>
      {showFilters && (
        <Filter
          fields={sortFields}
          data={orgsData}
          handleFilter={onFilter}
          handleReset={onResetFilters}
        ></Filter>
      )}
      <div className="customers-list-wrapper-table">
        {loading && <div>Loading</div>}
        {orgsData && !loading && (
          <TablePagination
            headers={tableHeaders}
            columns={columns}
            rows={filteredOrgs}
            pagination={true}
            handleRowClick={(id) => {
              navigate(`/organizations/${id}`);
            }}
          ></TablePagination>
        )}
      </div>
      {showSnackbar && (
        <SnackBar
          msg={'ארגון נוסף'}
          handleClose={() => setShowSnakbar(false)}
        ></SnackBar>
      )}
    </div>
  );
};

export default OrganizationsList;
